import { BANNER_EVENT_DATA, BANNER_EVENT_ERROR, BANNER_EVENT_FETCH } from "./constants";
import { BannerEventAction, BannerEventState } from "./types";

const initState: BannerEventState = {
    status: "init",
    error: null,
    data: {
        httpStatusCode: 200,
        data: {
            items: [],
            total: 0
        }
    }
}

export function bannerEventReducer(state = initState, action: BannerEventAction): BannerEventState {
    switch (action.type) {
        case BANNER_EVENT_FETCH:
            return { ...state, status: "loading" };
        case BANNER_EVENT_DATA:
            return { ...state, status: "success", data: action.payload };
        case BANNER_EVENT_ERROR:
            return { ...state, status: "error", error: action.payload };
        default:
            return state;
    }
}
